import { render, staticRenderFns } from "./EmptyLocationIcon.vue?vue&type=template&id=62c0c3d0"
import script from "./EmptyLocationIcon.vue?vue&type=script&lang=js"
export * from "./EmptyLocationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports